// extracted by mini-css-extract-plugin
export var completionBody = "_jf-2";
export var completionCard = "_jf-0";
export var completionFooter = "_jf-3";
export var completionTitle = "_jf-1";